import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './H4.scss'

function H4({ children, className }) {
  const componentClass = cx(style.h4, { [className]: className })
  return <h4 className={componentClass}>{children}</h4>
}

H4.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default H4



// WEBPACK FOOTER //
// ./src/components/Common/H4.js